export default {
  setup: "Step 1.1",
  setupService: "Setup Ordering Services",
  pickupBranches: "Pickup Branches",
  brandSettings: "Brand Settings",
  menu: "Menu",
};
